import { useEffect, useState } from "react";
import url from "../ServerUrl";

const Donations = () => {

    const [donations, setDonations] = useState([])
    const [error, setError] = useState("")

    const loadDonations = async() => {
        let headersList = {
            "Accept": "*/*",
            "User-Agent": "Thunder Client (https://www.thunderclient.com)",
            "Content-Type": "application/json",
            "token": localStorage.token
        }
        let bodyContent = JSON.stringify({
            "query": `getDonationsData`
        });
        
        let response = await fetch(`${url}/resolveQuery`, { 
            method: "POST",
            body: bodyContent,
            headers: headersList
        });
        if (!response.ok) throw new Error("Unable to load donations");
        let data = await response.json();
        setDonations(Array.isArray(data) ? data : [])
        
    }
    useEffect(()=>{
        loadDonations().catch(() => setError("Unable to load donations. Please refresh and try again."))
    },[])


    return(
        <div className="admin_ambulances">
            <h1>Donations</h1>
            <p style={{marginLeft: "20px",color: "#ff5049"}} ><b>Current Donations ({donations.length})</b></p>
            {error && <p className="drivers-message">{error}</p>}


            <table className="history_table"><thead>
                <tr className="history_table_header">
                    <th>Donation ID</th>
                    <th>Donor ID</th>
                    <th>Donor Email</th>
                    <th>Donor Contact</th>
                    <th>Time</th>
                    <th>Donor Amount</th>

                </tr></thead><tbody>{donations.map(item => {
                    return <tr key={item.donationid}>
                        <td>{item.donationid}</td>
                        <td>{item.donorid}</td>
                        <td>{item.email}</td>
                        <td>{item.contact}</td>
                        <td>{item.donatedon}</td>
                        <td>{item.donatedamount}</td>
                    </tr>
                })}{donations.length === 0 && <tr><td className="drivers-empty" colSpan="6">No donation records found in the local database.</td></tr>}</tbody>

            </table>
        </div>
    )
}
export default Donations;
